import React from 'react';
import PropTypes from 'prop-types';

const LocationsList = props => (
    <div className="location-finder-list">
        <div className="location-finder-list__count">
            <h3 className="location-finder-list__heading">
                <span className="location-finder-list__heading-text">
                    {props.locations.length}{' '}
                    Partner:
                </span>
            </h3>
        </div>
        {props.locations.map(location => (
            <div
                key={location.id}
                className="location-finder-list__item"
                onClick={() => props.toggleLocation(location.id)}
                onKeyUp={() => props.toggleLocation(location.id)}
                role="button"
                tabIndex="0"
            >
                <h3 className="location-finder-list__heading">
                    <span className="location-finder-list__heading-text">
                        {location.title}
                    </span>
                </h3>
                <p>{location.category.title}<br/><br/></p>
                <div className="location-finder-list__details">
                    {location.street}
                    <br />
                    {location.zipCode} {location.place}
                    <br />
                    Tel:{' '}
                    <a className="text" href={`tel:${location.phone}`}>
                        {location.phoneFormatted}
                    </a>
                </div>
            </div>
        ))}
    </div>
);

LocationsList.propTypes = {
    locations: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default LocationsList;



// WEBPACK FOOTER //
// ./static/js/modules/locations-finder/LocationsList.js